import { studentRequests } from "api/studentApi";
import { useEffect } from "react";
import { ReferenceInput } from "react-admin";
import { useFormContext } from "react-hook-form";
import AutoPickSelectInput from "server/components/Fields/AutoPickSelectInput";

const AcademicYearSessionInput = ({
  defVal,
  readOnly,
  curriculumId,
  instructionLanguageId,
  academicYearId,
  studyTypeId,
}) => {
  const { setValue } = useFormContext();

  useEffect(() => {
    if (defVal) {
      setValue("academicYearSessionId", defVal, { shouldDirty: false });
    }
  }, [defVal, setValue]);

  if (!studyTypeId) return null;

  return (
    <ReferenceInput
      key={studyTypeId}
      source="academicYearSessionId"
      reference={studentRequests.getAcademicSessionsSelect()}
      filter={{ academicYearId, curriculumId, onlySemesters: true, instructionLanguageId, studyTypeId }}
    >
      <AutoPickSelectInput
        label="Семестър"
        source="academicYearSessionId"
        optionText="sessionTypeText"
        fullWidth
        isRequired
        emptyText={false}
        readOnly={readOnly}
      />
    </ReferenceInput>
  );
};

export default AcademicYearSessionInput;
